export class MoleculePanelServiceObjectWebspaceComponent {
    public templateUrl = require('./panel-service-object-webspace.html?external');
}
